import '../../stylus/components/_grid.styl'

import Grid from './grid'

export default Grid('layout')



// WEBPACK FOOTER //
// ./src/components/VGrid/VLayout.js